import React from "react";
import UserForm from "../form";

const UpdateUser = () => {
  return (
    <div className="lg:p-6 p-4 max-w-md">
      <UserForm />
    </div>
  );
};

export default UpdateUser;
